import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { type LucideIcon } from 'lucide-react'

interface QueueCardProps {
  title: string
  count: number
  urgentCount?: number
  icon: LucideIcon
  href?: string
  loading?: boolean
}

export function QueueCard({
  title,
  count,
  urgentCount,
  icon: Icon,
  loading = false,
}: QueueCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="h-8 w-16 bg-muted animate-pulse rounded" />
        ) : (
          <>
            <div className="text-2xl font-bold">{count.toLocaleString()}</div>
            {urgentCount !== undefined && urgentCount > 0 && (
              <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                <Badge variant="destructive" className="text-xs px-1.5 py-0">
                  {urgentCount}
                </Badge>
                <span>เร่งด่วน</span>
              </p>
            )}
          </>
        )}
      </CardContent>
    </Card>
  )
}
